export const enCb = {
    myGeotabLogin: {
        loginText: 'Log in',
        registerText: 'Register',
    },
    notFound: {
        title: '404 Not Found | Geotab',
        heading: 'Oh no!',
        description: 'The page you were looking for could not be found.',
        description2: 'Try searching or go back to',
        homepageLink: 'our homepage',
    },
    salesforce: {
        formLanguage: 'English CB',
    },
    aboutAuthor: {
        about: 'About',
        currentRole: 'Current role',
        experties: 'Expertise',
        accomplishments: 'Accomplishments',
        education: 'Education',
        publications: 'Publications',
    },
    breadcrumb: {
        home: 'Home',
    },
};
